<ng-container *ngIf="!isHidden">
  <form [formGroup]="editForm">
    <div>
      <div>
        <div class="displayOrEditContainer" #displayOrEditContainer>
          <!-- ROW IN DISPLAY MODE -->
          <div class="form-row tableRowDisplayMode" #tableRowDisplayMode>
            <div class="col-lg-2" style="max-width: 50px">
              <label class="tableInfo rowIndex">
                {{ editForm.get("period").value }}
              </label>
            </div>
            <div
              class="col-lg-2"
              [class.dirty]="callNoticeDate?.edited"
              *ngIf="columnVisibility.callNoticeDate"
            >
              <label
                class="tableInfo"
                [ngbPopover]="
                  callNoticeDate?.edited
                    ? 'Modified from: ' +
                      (callNoticeDate?.original | dateToString)
                    : ''
                "
                triggers="mouseenter:mouseleave"
              >
                {{
                  callNoticeDate?.edited ?? callNoticeDate?.original
                    | dateToString
                }}
              </label>
            </div>
            <div class="col-lg-1" *ngIf="columnVisibility.barrierLevel">
              <label class="tableInfo">
                {{
                  isEditing$
                    | async
                    | barrierLevel: featureForm : editForm : groupName : type
                }}
              </label>
            </div>
            <div class="col-lg-1" *ngIf="columnVisibility.rangeAccrualRate">
              <label class="tableInfo">
                {{ rangeAccrualRate?.value }}
              </label>
            </div>
            <div class="col-lg-1" *ngIf="columnVisibility.lowerLevel">
              <label class="tableInfo">
                {{
                  isEditing$
                    | async
                    | barrierLevel: featureForm : editForm : groupName : type : 'lower'
                }}
              </label>
            </div>
            <div class="col-lg-1" *ngIf="columnVisibility.upperLevel">
              <label class="tableInfo">
                {{
                  isEditing$
                    | async
                    | barrierLevel: featureForm : editForm : groupName : type : 'upper'
                }}
              </label>
            </div>
            <div
              class="col-lg-1"
              *ngIf="columnVisibility.redemptionAmountPayable_relative"
            >
              <label class="tableInfo">
                {{
                  isEditing$ | async | redemptionAmount: featureForm : editForm : groupName : type
                }}
              </label>
            </div>
            <div
              class="col-lg-2"
              [class.dirty]="unadjustedObsEndDate?.edited"
              [style.maxWidth]="templateSettings.obsDateColWidth"
              *ngIf="columnVisibility.unadjObsDate"
            >
              <label
                class="tableInfo unadjObsDate"
                [ngbPopover]="
                  unadjustedObsEndDate?.edited
                    ? 'Modified from: ' +
                      (unadjustedObsEndDate?.original | dateToString)
                    : ''
                "
                triggers="mouseenter:mouseleave"
              >
                {{
                  unadjustedObsEndDate?.edited ?? unadjustedObsEndDate?.original
                    | dateToString
                }}
              </label>
            </div>

            <div
              *ngIf="columnVisibility.adjObsDate"
              class="col-lg-2"
              [style.maxWidth]="templateSettings.obsDateColWidth"
              [class.dirty]="adjustedObsEndDate?.edited"
            >
              <label
                class="tableInfo adjObsDate"
                [ngbPopover]="
                  adjustedObsEndDate?.edited
                    ? 'Modified from: ' +
                      (adjustedObsEndDate?.original | dateToString)
                    : ''
                "
                triggers="mouseenter:mouseleave"
              >
                {{
                  adjustedObsEndDate?.edited ?? adjustedObsEndDate?.original
                    | dateToString
                }}
              </label>
            </div>

            <div
              class="col-lg-2"
              [class.dirty]="rateDeterminationDateValue?.edited"
              *ngIf="columnVisibility.rateDeterminationDate"
            >
              <label
                class="tableInfo unadjObsDate"
                [ngbPopover]="
                  rateDeterminationDateValue?.edited
                    ? 'Modified from: ' +
                      (rateDeterminationDateValue?.original | dateToString)
                    : ''
                "
                triggers="mouseenter:mouseleave"
              >
                {{
                  rateDeterminationDateValue?.edited ??
                    rateDeterminationDateValue?.original | dateToString
                }}
              </label>
            </div>

            <div
              *ngIf="columnVisibility.accrualStartDate"
              class="col-lg-2"
              [class.dirty]="accrualPeriodStart?.edited"
            >
              <label
                class="tableInfo"
                [ngbPopover]="
                  accrualPeriodStart?.edited
                    ? 'Modified from: ' +
                      (accrualPeriodStart?.original | dateToString)
                    : ''
                "
                triggers="mouseenter:mouseleave"
              >
                {{
                  accrualPeriodStart?.edited ?? accrualPeriodStart?.original
                    | dateToString
                }}
              </label>
            </div>
            <div
              *ngIf="columnVisibility.accrualStartDate"
              class="col-lg-2"
              [class.dirty]="accrualPeriodEnd?.edited"
            >
              <label
                class="tableInfo"
                [ngbPopover]="
                  accrualPeriodEnd?.edited
                    ? 'Modified from: ' +
                      (accrualPeriodEnd?.original | dateToString)
                    : ''
                "
                triggers="mouseenter:mouseleave"
              >
                {{
                  accrualPeriodEnd?.edited ?? accrualPeriodEnd?.original
                    | dateToString
                }}
              </label>
            </div>
            <div
              class="col-lg-2"
              [class.dirty]="unadjustedPaymentDate?.edited"
              [style.maxWidth]="templateSettings.obsDateColWidth"
              *ngIf="columnVisibility.unadjPmtDate"
            >
              <label
                class="tableInfo unadjPmtDate"
                [ngbPopover]="
                  unadjustedPaymentDate?.edited
                    ? 'Modified from: ' +
                      (unadjustedPaymentDate?.original | dateToString)
                    : ''
                "
                triggers="mouseenter:mouseleave"
              >
                {{
                  !isEditable
                    ? "DEFERRED"
                    : (unadjustedPaymentDate?.edited ??
                        unadjustedPaymentDate?.original | dateToString)
                }}
              </label>
            </div>
            <div class="col-lg-1" [class.dirty]="adjustedPaymentDate?.edited">
              <label
                class="tableInfo"
                [ngbPopover]="
                  adjustedPaymentDate?.edited
                    ? 'Modified from: ' +
                      (adjustedPaymentDate?.original | dateToString)
                    : ''
                "
                triggers="mouseenter:mouseleave"
              >
                {{
                  !isEditable
                    ? "DEFERRED"
                    : (adjustedPaymentDate?.edited ??
                        adjustedPaymentDate?.original | dateToString)
                }}
              </label>
            </div>

            <div class="col-lg-1 text-right" style="max-width: 50px">
              <button
                class="editButton"
                (click)="editRow(tableRowDisplayMode, tableRowEditMode)"
                [disabled]="!isEditable"
              >
                <img
                  src="assets/edit.svg"
                  class="rowSvg"
                  [class.disabled]="!isEditable"
                  alt="Edit icon"
                />
              </button>
            </div>
          </div>

          <!-- ROW IN EDIT MODE -->
          <div class="form-row tableRowEditMode displayNone" #tableRowEditMode>
            <ng-container *ngIf="!isLoading">
              <div class="col-lg-1" style="max-width: 50px">
                <label class="tableInfo rowIndex">
                  {{ editForm.get("period").value }}
                </label>
              </div>
              <div
                class="col-lg-2"
                [style.maxWidth]="templateSettings.obsDateColWidth"
                *ngIf="columnVisibility.callNoticeDate"
              >
                <app-dc-original-and-edited-date-input
                  [originalAndEditedDate]="callNoticeDate"
                  [id]="'callNoticeDate'"
                ></app-dc-original-and-edited-date-input>
              </div>
              <div class="col-lg-1" *ngIf="columnVisibility.barrierLevel">
                <app-dc-input-number-percent-indicative-final
                  formControlName="barrierLevel"
                  defaultUnit="pct"
                  *ngIf="
                    featureForm.get('barrier')?.get('type')?.value ===
                      'CUSTOM' &&
                      editForm.get('barrierLevel')?.value?.value !== 'Deferred';
                    else barrierLevelRef
                  "
                ></app-dc-input-number-percent-indicative-final>
                <ng-template #barrierLevelRef>
                  <label class="tableInfo">
                    {{
                      featureForm.get("barrier")?.get("type")?.value
                        | barrierLevel: featureForm:editForm:groupName:type
                    }}
                  </label>
                </ng-template>
              </div>
              <div class="col-lg-1" *ngIf="columnVisibility.rangeAccrualRate">
                <label class="tableInfo">
                  {{ rangeAccrualRate?.value }}
                </label>
              </div>
              <div class="col-lg-1" *ngIf="columnVisibility.lowerLevel">
                <app-dc-input-number-percent-indicative-final
                  *ngIf="featureForm.get('barrier.type')?.value === 'CUSTOM'; else barrierLevelRef"
                  [formControlName]="'lowerLevel'"
                  [defaultUnit]="'pct'"
                ></app-dc-input-number-percent-indicative-final>
                <ng-template #barrierLevelRef>
                  <label class="tableInfo">
                    {{
                      featureForm.get("barrier.type")?.value
                        | barrierLevel: featureForm:editForm:groupName:type:'lower'
                    }}
                  </label>
                </ng-template>
              </div>
              <div class="col-lg-1" *ngIf="columnVisibility.upperLevel">
                <app-dc-input-number-percent-indicative-final
                  *ngIf="featureForm.get('barrier.type')?.value === 'CUSTOM'; else barrierLevelRef"
                  [formControlName]="'upperLevel'"
                  [defaultUnit]="'pct'"
                ></app-dc-input-number-percent-indicative-final>
                <ng-template #barrierLevelRef>
                  <label class="tableInfo">
                    {{
                      featureForm.get("barrier.type")?.value
                        | barrierLevel: featureForm:editForm:groupName:type:'upper'
                    }}
                  </label>
                </ng-template>
              </div>
              <div
                class="col-lg-1"
                *ngIf="columnVisibility.redemptionAmountPayable_relative"
              >
                <label class="tableInfo">
                  {{
                    editForm.get("redemptionAmountPayable_relative")?.value
                      ?.value ?? "-"
                  }}
                </label>
              </div>
              <div
                class="col-lg-2"
                [style.maxWidth]="templateSettings.obsDateColWidth"
                *ngIf="
                  columnVisibility.unadjObsDate &&
                  editForm.get('observations').length
                "
              >
                <ng-container formArrayName="observations">
                  <ng-container [formGroupName]="0">
                    <app-dc-original-and-edited-date-input
                      [originalAndEditedDate]="unadjustedObsEndDate"
                      [id]="'unadjustedObsEndDate'"
                    ></app-dc-original-and-edited-date-input>
                  </ng-container>
                </ng-container>
              </div>
              <div
                class="col-lg-2"
                [style.maxWidth]="templateSettings.obsDateColWidth"
                *ngIf="columnVisibility.adjObsDate"
              >
                <ng-container
                  *ngIf="observationsValue.length > 0"
                  formArrayName="observations"
                >
                  <ng-container [formGroupName]="0">
                    <app-dc-original-and-edited-date-input
                      [originalAndEditedDate]="adjustedObsEndDate"
                      [id]="'adjustedObsEndDate'"
                    ></app-dc-original-and-edited-date-input>
                  </ng-container>
                </ng-container>
              </div>
              <div
                class="col-lg-2"
                *ngIf="columnVisibility.rateDeterminationDate"
              >
                <ng-container *ngIf="rateDeterminationDateValue?.original?.day">
                  <app-dc-original-and-edited-date-input
                    [originalAndEditedDate]="rateDeterminationDateValue"
                    [id]="'rateDeterminationDate'"
                  ></app-dc-original-and-edited-date-input>
                </ng-container>
              </div>
              <ng-container>
                <div class="col-lg-2" *ngIf="columnVisibility.accrualStartDate">
                  <app-dc-original-and-edited-date-input
                    [originalAndEditedDate]="accrualPeriodStart"
                    [id]="'accrualPeriodStart'"
                  ></app-dc-original-and-edited-date-input>
                </div>
                <div class="col-lg-2" *ngIf="columnVisibility.accrualStartDate">
                  <app-dc-original-and-edited-date-input
                    [originalAndEditedDate]="accrualPeriodEnd"
                    [id]="'accrualPeriodEnd'"
                  ></app-dc-original-and-edited-date-input>
                </div>
                <div
                  class="col-lg-2"
                  [style.maxWidth]="templateSettings.obsDateColWidth"
                  *ngIf="columnVisibility.unadjPmtDate"
                >
                  <app-dc-original-and-edited-date-input
                    [originalAndEditedDate]="unadjustedPaymentDate"
                    [id]="'unadjustedPaymentDate'"
                  ></app-dc-original-and-edited-date-input>
                </div>
                <div class="col-lg-1">
                  <app-dc-original-and-edited-date-input
                    [originalAndEditedDate]="adjustedPaymentDate"
                    [id]="'adjustedPaymentDate'"
                  ></app-dc-original-and-edited-date-input>
                </div>
              </ng-container>
              <div
                class="col-lg-1 text-right"
                style="max-width: 60px; min-width: 55px"
              >
                <button
                  class="cancelButton"
                  (click)="cancelRowEdit(tableRowDisplayMode, tableRowEditMode)"
                >
                  <img
                    src="assets/cancel-small-grey.svg"
                    class="rowSvg"
                    alt="Cancel icon"
                  />
                </button>
                <button
                  class="doneButton"
                  (click)="doneRowEdit(tableRowDisplayMode, tableRowEditMode)"
                >
                  <img
                    src="assets/tick-small-green.svg"
                    class="rowSvg"
                    alt="Done icon"
                  />
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
